import React from 'react';

const IrelandFlagIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="ireland 1">
            <g clipPath="url(#clip0_1172_816)">
                <path id="rect171" d="M13.9999 0.108215H0V14.1082H13.9999V0.108215Z" fill="white" />
                <path id="rect403" d="M4.66667 0.108215H0V14.1082H4.66667V0.108215Z" fill="#319400" />
                <path id="rect135" d="M14.0002 0.108215H9.3335V14.1082H14.0002V0.108215Z" fill="#E76310" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1172_816">
                <rect y="0.108215" width="14" height="14" rx="5.25" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default IrelandFlagIcon;
